import { render } from "./LinkAccount.vue?vue&type=template&id=45d18f3c&scoped=true"
import script from "./LinkAccount.vue?vue&type=script&lang=js"
export * from "./LinkAccount.vue?vue&type=script&lang=js"

import "./LinkAccount.vue?vue&type=style&index=0&id=45d18f3c&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d18f3c"]])

export default __exports__